import React, { SVGProps } from "react";

const Snowflake = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="55" height="96" viewBox="0 0 55 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M96 40.6953H64.7754L86.7893 18.6959L76.8424 8.75028L55.0111 30.5848V0H40.9477V30.8262L19.0811 8.9564L9.13417 18.902L30.9301 40.6953H0V54.7629H30.83L8.9575 76.6269L18.9043 86.5726L40.9418 64.5319V96H55.0052V64.7793L77.0073 86.7786L86.9542 76.8389L64.8755 54.7629H95.9941V40.6953H96Z"
        fill="#B1FFF7"
      />
    </svg>
  );
};

Snowflake.displayName = "Snowflake";

export default Snowflake;
